export default function (settings) {
  var gtmObjectPath = settings.gtmObjectPath || "dataLayer";
  var timeoutLoadAnalytic = 3;
  var checksStartedAt;
  var clientTrackerName;
  var dataLayer;
  var eventName = function (name) {
    var ga = window[window["GoogleAnalyticsObject"] || "ga"];
    var gaSettings = settings.analytics.ga;

    if (name != "send" || !gaSettings.clientTrackerId) return name;

    if (clientTrackerName) return clientTrackerName + "." + name;

    const tracker = ga
      .getAll()
      .find(
        (tracker) => tracker.get("trackingId") === gaSettings.clientTrackerId
      );

    if (!tracker || !tracker.get("name")) return name;

    clientTrackerName = tracker.get("name");

    return clientTrackerName + "." + name;
  };

  var checkingLoadAnalytic = function (event) {
    var ga = window[window["GoogleAnalyticsObject"] || "ga"];

    var loadGAHandler = function () {
      ga = window[window["GoogleAnalyticsObject"] || "ga"];

      // ga('create', settings.analytics.ga.frisbuyTrackerId, 'auto', 'frisbuyGa');
      // ga('frisbuyGa.send', 'pageview');

      window.frisbuy.gaReady = true;

      if (settings.verbose) {
        console.log("frisbuyGa.loaded:", window.ga.loaded);
      }

      window.frisbuy.frisbuyGaEvents.forEach(function (GaEvent) {
        if (settings.verbose) {
          console.log("Dequeued GA Event:", GaEvent);
        }

        if (GaEvent.length === 5) {
          ga(
            eventName(GaEvent[0]),
            GaEvent[1],
            GaEvent[2],
            GaEvent[3],
            GaEvent[4]
          );
        } else {
          ga(
            eventName(GaEvent[0]),
            GaEvent[1],
            GaEvent[2],
            GaEvent[3],
            GaEvent[4],
            GaEvent[5]
          );
        }
      });

      window.frisbuy.frisbuyGaEvents = [];
    };

    var timeDiff = Date.now() - checksStartedAt;

    if (typeof ga === "function" && ga.loaded) {
      clearInterval(checkingGAInterval);
      window.removeEventListener("load", checkingLoadAnalytic);

      if (settings.analytics.ga.sendToGa) {
        loadGAHandler();
      }
    } else if (
      event ||
      (!settings.clientHasGa && timeDiff > timeoutLoadAnalytic * 1000)
    ) {
      if (settings.clientHasGa) {
        console.warn(
          "Client's Google Analytics object expected, but not loaded in " +
            Math.round(timeDiff / 1000) +
            "s"
        );
      }

      clearInterval(checkingGAInterval);
      window.removeEventListener("load", checkingLoadAnalytic);

      if (!settings.analytics.ga.sendToGa) {
        return;
      }

      (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        (i[r] =
          i[r] ||
          function () {
            (i[r].q = i[r].q || []).push(arguments);
          }),
          (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        "script",
        "https://www.google-analytics.com/analytics.js",
        "ga"
      );

      document
        .querySelector('script[src*="google-analytics"]')
        .addEventListener("load", loadGAHandler);
    }
  };
  var checkingLoadGTM = function (event) {
    // проверям, полностью ли инициализирован tagManager
    var isGtmReady =
      window.google_tag_manager &&
      window.google_tag_manager.dataLayer &&
      window.google_tag_manager.dataLayer.gtmDom;

    // завершилась загрузка всех скриптов
    if (isGtmReady || event) {
      // отписываемся от событий, ждать больше нечего
      clearInterval(checkingGTMInterval);
      window.removeEventListener("load", checkingLoadGTM);

      // пытаемся достать dataLayer
      dataLayer = gtmObjectPath
        .split(".")
        .reduce((previousValue, currentValue) => {
          if (!previousValue) return undefined;

          return previousValue[currentValue];
        }, window);

      // GTM не смог загрузиться, загрузка завершена, а dataLayer-а нет
      if (!dataLayer) {
        console.warn(
          `Init sequence finished, but ${settings.gtmObjectPath} is undefined`
        );
      } else {
        if (!isGtmReady) {
          console.warn(
            `${gtmObjectPath} is defined, but GTM is not initialized at the end of init sequence`
          );
        }

        // пушим
        window.frisbuy.frisbuyGTMEvents.forEach(function (GtmEvent) {
          if (settings.verbose) {
            console.log("Dequeued GTM event:", GtmEvent);
          }
          dataLayer.push(GtmEvent);
        });

        window.frisbuy.frisbuyGTMEvents = [];
      }
    }
  };
  var checkingLoadGA4 = function (event) {
    var gtag = window.gtag;
    var trackerIdProvided =
      settings.analytics.ga4.frisbuyTrackerId ||
      settings.analytics.ga4.clientTrackerId;

    var loadGA4Handler = function () {
      gtag = window.gtag;

      if (settings.verbose) {
        console.log("checkingLoadGA4");
        console.log(
          "settings.analytics.ga4.frisbuyTrackerId",
          settings.analytics.ga4.frisbuyTrackerId
        );
        console.log(
          "settings.analytics.ga4.clientTrackerId",
          settings.analytics.ga4.clientTrackerId
        );
      }

      gtag("js", new Date());
      if (
        settings.analytics.ga4.frisbuyTrackerId &&
        settings.analytics.ga4.clientTrackerId
      ) {
        gtag("config", settings.analytics.ga4.frisbuyTrackerId, {
          groups: "frisbuy",
        });
        gtag("config", settings.analytics.ga4.clientTrackerId, {
          groups: "frisbuy",
        });
      } else {
        gtag("config", trackerIdProvided, { groups: "frisbuy" });
      }

      window.frisbuy.ga4Ready = true;

      window.frisbuy.frisbuyGa4Events.forEach(function (GA4Event) {
        if (settings.verbose) {
          console.log(
            "checkingLoadGA4 >>> window.frisbuy.frisbuyGa4Events.forEach GA4Event",
            GA4Event
          );
        }

        gtag(GA4Event[0], GA4Event[1], GA4Event[2]);
      });

      window.frisbuy.frisbuyGa4Events = [];
    };

    var timeDiff = Date.now() - checksStartedAt;

    if (typeof gtag === "function" && trackerIdProvided) {
      clearInterval(checkingGA4Interval);
      window.removeEventListener("load", checkingLoadGA4);
      loadGA4Handler();
    } else if (event || timeDiff > timeoutLoadAnalytic * 1000) {
      clearInterval(checkingLoadGA4);
      window.removeEventListener("load", checkingLoadGA4);

      if (!window.frisbuy.ga4ManualLoaded) {
        if (
          settings.analytics.ga4.frisbuyTrackerId ||
          settings.analytics.ga4.clientTrackerId
        ) {
          var docHead = document.querySelector("head");
          var ga4Script = document.createElement("script");
          ga4Script.async = true;
          ga4Script.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=" +
              trackerIdProvided +
              "&l=dataLayer"
          );
          docHead.appendChild(ga4Script);

          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          window.gtag = gtag;

          window.frisbuy.ga4ManualLoaded = true;
        }
      }
    }
  };
  var checkingGAInterval = null;
  var checkingGTMInterval = null;
  var checkingGA4Interval = null;
  window.frisbuy = window.frisbuy || {};

  window.frisbuy.frisbuyGaEvents = window.frisbuy.frisbuyGaEvents || [];
  window.frisbuy.frisbuyGTMEvents = window.frisbuy.frisbuyGTMEvents || [];
  window.frisbuy.frisbuyGa4Events = window.frisbuy.frisbuyGa4Events || [];
  window.frisbuy.gaReady = window.frisbuy.gaReady || false;
  window.frisbuy.ga4Ready = window.frisbuy.ga4Ready || false;

  window.frisbuyGa = function () {
    var ga = window[window["GoogleAnalyticsObject"] || "ga"];
    const isAnalyticsAvailable = ga && ga.getAll;

    if (
      window.frisbuy.gaReady ||
      (isAnalyticsAvailable && !settings.analytics.ga.sendToGa)
    ) {
      if (settings.verbose) {
        console.log("Sent GA event:", arguments);
      }

      if (arguments.length === 5) {
        ga(
          eventName(arguments[0]),
          arguments[1],
          arguments[2],
          arguments[3],
          arguments[4]
        );
      } else {
        ga(
          eventName(arguments[0]),
          arguments[1],
          arguments[2],
          arguments[3],
          arguments[4],
          arguments[5]
        );
      }
    } else {
      if (settings.verbose) {
        console.log("Queued GA event:", arguments);
      }

      window.frisbuy.frisbuyGaEvents.push(arguments);
    }
  };

  window.frisbuyGTM = function (gtmPayload) {
    if (dataLayer) {
      dataLayer.push(gtmPayload);
      if (settings.verbose) {
        console.log(`${gtmObjectPath}.push`, gtmPayload);
      }
    } else {
      window.frisbuy.frisbuyGTMEvents.push(gtmPayload);
      if (settings.verbose) {
        console.log(`queued ${gtmObjectPath}.push`, gtmPayload);
      }
    }
  };

  window.frisbuyGa4 = function () {
    if (settings.verbose) {
      console.log("window.frisbuyGa4 arguments");
      console.log("window.frisbuyGa4 arguments[0]", arguments[0]);
      console.log("window.frisbuyGa4 arguments[1]", arguments[1]);
      console.log("window.frisbuyGa4 arguments[2]", arguments[2]);
    }

    var gtag = window.gtag;

    if (window.frisbuy.ga4Ready) {
      if (
        window.frisbuy.frisbuyGa4Events &&
        window.frisbuy.frisbuyGa4Events.length > 0
      ) {
        window.frisbuy.frisbuyGa4Events.forEach(function (GA4Event) {
          if (settings.verbose) {
            console.log(
              "widget window.frisbuyGa4 >>> window.frisbuy.frisbuyGa4Events.forEach GA4Event",
              GA4Event
            );
          }

          gtag(GA4Event[0], GA4Event[1], GA4Event[2]);
        });

        window.frisbuy.frisbuyGa4Events = [];
      }

      gtag(arguments[0], arguments[1], arguments[2]);
    } else {
      window.frisbuy.frisbuyGa4Events.push(arguments);

      if (settings.verbose) {
        console.log(
          "widget window.frisbuyGa4 >>> window.frisbuy.frisbuyGa4Events after push",
          window.frisbuy.frisbuyGa4Events
        );
      }
    }
  };

  checksStartedAt = Date.now();
  checkingGAInterval = setInterval(checkingLoadAnalytic, 1000);
  checkingGA4Interval = setInterval(checkingLoadGA4, 1000);
  checkingGTMInterval = setInterval(checkingLoadGTM, 1000);

  window.addEventListener("load", checkingLoadAnalytic);
  window.addEventListener("load", checkingLoadGA4);
  window.addEventListener("load", checkingLoadGTM);
}
